module.exports = __webpack_public_path__ + "static/media/static-1.c75ad330.jpg";